import { Timeline as VisTimeline } from "vis-timeline/peer"
import { DataSet } from "vis-data/peer"
import moment from 'moment'

export default class Timeline {
  constructor(root, items, groups, startDate, endDate) {
    this._timeline = new VisTimeline(root)
    this._groups = new DataSet(groups)
    this._items = new DataSet(items)
    this._startDate = startDate
    this._endDate = endDate
    this.timeline.setOptions(this._options())
    this.timeline.setGroups(this.groups)
    this.timeline.setItems(this.items)
    const currentDateIndicator = root.querySelector('.vis-current-time')
    currentDateIndicator.setAttribute('data-current-date', new Date().getDate().toString())
    this.timeline
  }

  get timeline() { return this._timeline }
  get groups() { return this._groups }
  get items() { return this._items }

  _options() {
    return {
      orientation: "top",
      editable: false,
      dataAttributes: ['id'],
      multiselect: true,
      groupEditable: true,
      stack: false,
      showCurrentTime: true,
      zoomKey: 'shiftKey',
      start: moment(this._startDate).format('YYYY-MM-DD'),
      end: moment(this._endDate).endOf('month').format('YYYY-MM-DD'),
      locale: 'en',
      format: {
        minorLabels: {
          week: 'ddd D',
        }
      }
    }
  }
}
